import { DownloadOption } from 'types';
import { baseApi } from '../base';
import { type ISongDownloadInfo } from '../entities';
import { type AudioDownloadRendering } from '../entities/audioDownloadRendering';
import {
  transformToDownloadLimitError,
  tranformToSongDownloadInfo,
  transformToDownloadRenderingData,
} from './transformers';
import { DEFAULT_SONG_QUALITY } from './constants';
import { getDownloadQuality } from './helpers';

const songsApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    addToLibrary: build.mutation<void, { songId: string }>({
      query: ({ songId }) => ({
        method: 'POST',
        url: `/songs/library/${songId}`,
      }),
    }),
    removeFromLibrary: build.mutation<void, { songId: string }>({
      query: ({ songId }) => ({
        method: 'DELETE',
        url: `/songs/library/${songId}`,
      }),
    }),
    downloadSong: build.mutation<
      ISongDownloadInfo,
      { songId: string; downloadOption: DownloadOption }
    >({
      query: ({ songId, downloadOption }) => {
        const quality = getDownloadQuality(downloadOption);
        const songQuality = quality || DEFAULT_SONG_QUALITY;
        return {
          url: `/songs/${songId}/download?quality=${songQuality}`,
        };
      },
      transformResponse: tranformToSongDownloadInfo,
      transformErrorResponse: transformToDownloadLimitError,
    }),
    downloadStems: build.mutation<AudioDownloadRendering, { songId: string }>({
      query: ({ songId }) => ({
        url: `/songs/${songId}/stems`,
      }),
      transformResponse: transformToDownloadRenderingData,
      transformErrorResponse: transformToDownloadLimitError,
    }),
    downloadSamplePack: build.mutation<
      AudioDownloadRendering,
      { songId: string }
    >({
      query: ({ songId }) => ({
        url: `/songs/${songId}/sample-pack`,
      }),
      transformResponse: transformToDownloadRenderingData,
      transformErrorResponse: transformToDownloadLimitError,
    }),
  }),
});

export default songsApi;
